export interface Category {
  id: string;
  slug: string;
  name: string;
  description: string;
  icon: string;
  articleCount: number;
  imageSeq: string;
}

export const categories: Category[] = [
  {
    id: 'cat-01',
    slug: 'zaoxing-diy',
    name: '火影西瓜造型DIY',
    description: '手把手教你打造各种火影角色西瓜造型，从鸣人到佐助，从卡卡西到自来也，让夏日吃瓜也能秀出忍者魂！',
    icon: 'ri-brush-line',
    articleCount: 8,
    imageSeq: 'cat-diy-01',
  },
  {
    id: 'cat-02',
    slug: 'zhuti-qiefa',
    name: '主题切法教程',
    description: '火影忍者主题的创意西瓜切法大全，写轮眼切法、螺旋丸切法、尾兽切法等，让每一刀都充满忍道精神！',
    icon: 'ri-knife-line',
    articleCount: 6,
    imageSeq: 'cat-cut-01',
  },
  {
    id: 'cat-03',
    slug: 'renzhe-diaoke',
    name: '西瓜忍者雕刻',
    description: '高级西瓜雕刻艺术，将火影经典场景与角色融入西瓜雕刻，打造令人惊叹的忍者西瓜艺术品！',
    icon: 'ri-artboard-line',
    articleCount: 5,
    imageSeq: 'cat-carve-01',
  },
  {
    id: 'cat-04',
    slug: 'zhoubian-meishi',
    name: '火影周边美食',
    description: '火影主题西瓜美食周边推荐，西瓜主题甜品、饮品、零食大合集，让味蕾也感受忍者之力！',
    icon: 'ri-cake-line',
    articleCount: 7,
    imageSeq: 'cat-food-01',
  },
  {
    id: 'cat-05',
    slug: 'renzhe-pinpan',
    name: '忍者西瓜拼盘',
    description: '创意西瓜拼盘设计灵感，火影小队、忍界大战等主题拼盘，聚会派对必备的忍者风果盘方案！',
    icon: 'ri-layout-grid-line',
    articleCount: 5,
    imageSeq: 'cat-platter-01',
  },
];